import { Badge } from 'framework/ui/mui-builder';

const StateChip = ({ label }: { label: string }) => (
  <Badge sx={{ marginLeft: 0, backgroundColor: 'background.default', maxWidth: '100%' }}>{label}</Badge>
);

export default StateChip;
